import { useFavicon } from '@vueuse/core'

export default async function useCenterFavicon() {
  // Set favicon
  const { currentCenterProfile } = await useCurrentCenter()
  const icon = useFavicon()
  icon.value = currentCenterProfile.value?.faviconUrl || currentCenterProfile.value?.websiteLogoUrl
}
